import {
  ADD_ACCOUNTS,
  FETCHING_ACCOUNTS,
  FETCHED_ACCOUNTS,
  SET_CURRENT_ACCOUNT,
  SET_PRIMARY_ACCOUNT,
  CLEAR_ALL,
} from '../constants';

interface AccountsState {
  list: any[];
  current: any;
  primary: any;
  fetched: boolean;
  fetching: boolean;
}

const initialState: AccountsState = {
  list: [],
  current: false,
  primary: false,
  fetched: false,
  fetching: false,
};

const accountsReducer = (state = initialState, { type, payload }: { type: string; payload?: any }): AccountsState => {
  switch (type) {
    case FETCHING_ACCOUNTS:
      return { ...state, fetching: true };
    case FETCHED_ACCOUNTS:
      return { ...state, fetching: false };
    case ADD_ACCOUNTS:
      return {
        ...state,
        list: payload.accounts || [],
        current: payload.current || state.current,
        primary: payload.primary || state.primary,
        fetched: true,
        fetching: false,
      };
    case SET_CURRENT_ACCOUNT:
      return { ...state, current: payload };
    case SET_PRIMARY_ACCOUNT:
      return { ...state, primary: payload };
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
};

export default accountsReducer;
